import styled from 'styled-components';
import palette from '../../lib/styles/palette';
import PulleyEditor from './PulleyEditor';

const PulleyEditorForm = ({ pulleys, /*minPulleyDia,*/ drivePulley, handleChange, handleApplicationSelect, handleDiaSelection, handleEditDrivePulley, onAddPulley, onRemovePulley }) => {

    return (
        <PulleyEditorFormBlock>
            <h3>Pulley Selection</h3>
            <div style={{ display: 'flex' }}>
                <Title>
                    {/* {titleKeys && titleKeys.map((title, index) => <Input key={index} value={title} readOnly />)} */}
                    {/* <Input value="Pulley ID" readOnly /> */}
                    <Input value="Pulley Application" readOnly />
                    <Input value="Pulley Type Category" readOnly />
                    <Input value="Qty of Pulley(s)" readOnly />
                    <Input value="Resultant Force" readOnly />
                    <Input value="Torque" readOnly />
                    <Input value="Eccentric Factor" readOnly />
                    <Input value="Max. Moment" readOnly />
                    <Input value="Bearing Center Distance" readOnly />
                    <Input value="Pulley Web Plate Center Distance" readOnly />
                    <Input value="Length of Moment Arm" readOnly />
                    <Spacer />
                    <Input value="Shaft Dia. @Hub by Allowable Stress" readOnly />
                    <Input value="Shaft Dia. @Hub by Allowable Deflection(7')" readOnly />
                    <Input value="Shaft Dia. @Hub Selected" readOnly />
                    <Input value="Shaft Dia. @Bearing Calculated" readOnly />
                    <Input value="Bearing Dia. Selected" readOnly />
                    <Input value="Plummer Block Number" readOnly />
                    <Input value="Plummer Block Weight" readOnly />
                    <Input value="Bearing Number" readOnly />
                    <Input value="Dynamic Rating" readOnly />
                    <Input value="L10h Life" readOnly />
                    <Spacer />
                    <Input value="Min. Pulley Dia. w/o Lagging" readOnly />
                    <Input value="Min. Pulley Dia. by Belt" readOnly />
                    <Input value="Min. Pulley Dia. by Hub Dia" readOnly />
                    <Input value="Min. Pulley Dia. by Shape Ratio" readOnly />
                    <Input value="Pulley Dia. Selected w/o Lagging" readOnly />
                    <Input value="Lagging Thickness" readOnly />
                    <Input value="Pulley Dia. with Lagging" readOnly />
                    <Input value="Pulley RPM" readOnly />
                    <Spacer />
                    <Input value="Estimated Pulley Weight" readOnly />
                    <Spacer />
                    <button onClick={onAddPulley}>
                        Add Pulley
                    </button>
                </Title>
                <Title>
                    {/* {unitKeys && unitKeys.map((unit, index) => <Unit key={index} value={unit} readOnly />)} */}
                    {/* <Unit value="-" readOnly /> */}
                    <Unit value="" readOnly />
                    <Unit value="" readOnly />
                    <Unit value="ea" readOnly />
                    <Unit value="N" readOnly />
                    <Unit value="N-cm" readOnly />
                    <Unit value="-" readOnly />
                    <Unit value="N-cm" readOnly />
                    <Unit value="cm" readOnly />
                    <Unit value="cm" readOnly />
                    <Unit value="cm" readOnly />
                    <SpacerUnit />
                    <Unit value="cm" readOnly />
                    <Unit value="cm" readOnly />
                    <Unit value="cm" readOnly />
                    <Unit value="cm" readOnly />
                    <Unit value="cm" readOnly />
                    <Unit value="-" readOnly />
                    <Unit value="kg" readOnly />
                    <Unit value="-" readOnly />
                    <Unit value="?" readOnly />
                    <Unit value="?" readOnly />
                    <SpacerUnit />
                    <Unit value="mm" readOnly />    {/* minPulleyDia */}
                    <Unit value="mm" readOnly />
                    <Unit value="mm" readOnly />
                    <Unit value="mm" readOnly />
                    <Unit value="mm" readOnly />
                    <Unit value="mm" readOnly />
                    <Unit value="mm" readOnly />
                    <Unit value="1/min" readOnly />
                    <SpacerUnit />
                    <Unit value="kg" readOnly />
                </Title>
                {pulleys &&
                    pulleys.map((pulley) => (
                        <PulleyEditor
                            pulley={pulley}
                            // minPulleyDia={minPulleyDia}
                            drivePulley={drivePulley}
                            handleChange={handleChange}
                            handleApplicationSelect={handleApplicationSelect}
                            handleDiaSelection={handleDiaSelection}
                            handleEditDrivePulley={handleEditDrivePulley}
                            onAddPulley={onAddPulley}
                            onRemovePulley={onRemovePulley}
                        />
                    ))}
            </div>
        </PulleyEditorFormBlock>
    );
};

export default PulleyEditorForm;

const PulleyEditorFormBlock = styled.div`
    
`;

const Title = styled.div``;

const Input = styled.input`
    display: block;
    box-sizing: border-box;
    height: 35px;
    // padding: 0.5rem 0.5rem;
    border: none;
    outline: none;
    & + & {
        margin-top: 0.5rem;
    }
    font-size: 1rem;
    width: 350px;
    &: hover {
        background-color: ${palette.gray[1]};
        transition: 0.3s;
        cursor: default;
    }
`;

const Unit = styled.input`
    display: block;
    box-sizing: border-box;
    height: 35px;
    // padding: 0.5rem 0.5rem;
    border: none;
    outline: none;
    color: ${palette.gray[6]};
    & + & {
        margin-top: 0.5rem;
    }
    font-size: 0.9rem;
    width: 50px;

`;

const Spacer = styled.input`
    display: block;
    box-sizing: border-box;
    height: 10px;
    border: none;
    outline: none;
    margin: 0.5rem 0;
    // width: 120px;
    // background-color: yellow;

`;

const SpacerUnit = styled.input`
display: block;
box-sizing: border-box;
height: 10px;
border: none;
outline: none;
margin: 0.5rem 0;
width: 50px;
// background-color: yellow;

`;